module.exports = __webpack_public_path__ + "img/header.ef2a189.svg";